import React from 'react';
import { kumbhMelaInfo } from './kumbh_mela_special_trains_data';
import { crawlerDuplicateAvoidStyle } from '../../utils/commonUtils';

const KumbhMelaInfo = () => {
  return (
    <div className={'infoCard'}>
      <h2 style={crawlerDuplicateAvoidStyle} className="mobileShow font22 appendBottom15 latoLight">
        {`Check Out the Kumbh Mela Special Trains - 2021`}
      </h2>
      {kumbhMelaInfo.map(({ title, html }, index) => {
        return (
          <div className={'appendBottom20 darkGreyText'} key={index}>
            {title ? (
              <div
                className={'appendBottom10 latoBold blackText appendBottom5'}
                dangerouslySetInnerHTML={{
                  __html: title
                }}
              ></div>
            ) : null}
            <div dangerouslySetInnerHTML={{ __html: html }} key={index}></div>
          </div>
        );
      })}
    </div>
  );
};

export default KumbhMelaInfo;
